
import { defineComponent, onMounted } from "vue";
import { store } from "@/store";
import router from "@/router";

// import * as Audio from "@/game-engine/audio";

export default defineComponent({
  name: "App",
  setup() {
    onMounted(() => {
      if (!store.state.isDev) {
        router.push("/");
      }

      // Audio.awake();
    });

    return {};
  }
});
